import * as Vue from "vue"
import {processUser} from "../users/actions"
import * as mutations from "../../mutation-types"

export const userLogin = (store, data) => {
    return axios.post(`/login`, data)
        .then(res => {
            Laravel.currentUser = res.data.data
            setCurrentUser(store, res.data.data)
            return res
        })
}

export const userLogout = store => {
    return axios.post(`/logout`)
        .then(() => window.location = '/login')
}

export const processPresetUserData = store => {
    return new Promise((resolve, reject) => {
        let user = window.Laravel.currentUser || null
        setCurrentUser(store, user)
        resolve(user)
        return user
    })
}

export const setCurrentUser = (store, user) => {
    if (user) {
        processUser(store, user)
        //initializeEcho(user.id);
        window.Laravel.currentUser = user
    }
    store.commit(mutations.SET_CURRENT_USER, user)
}

export const forgotPassword = (store, data) => {
    return axios.post(`/password/email`, data)
}

export const resetPassword = (store, data) => {
    return axios.post(`/password/reset`, data)
}

export const hydrateApp = (store) => {
    store.commit('users.set-setting', {setting: 'is_billing_reimb_visible', value: localStorage.getItem('is_billing_reimb_visible') !== 'false'})

    return axios.get(`/api/dictionaries`)
        .then(res => {
            let data = res.data.data

            store.commit('clocklog.set', data.clocklog)
            store.commit('users.set', data.users)
            store.commit('work-types.set', data.work_types)
            store.commit('services.set', data.services)
            store.commit('permit-types.set', data.permit_types)
            store.commit('followed-projects.set', data.followedProjects)
            store.commit('settings.set', data.settings)
            store.commit('table-settings.set', data.tableSettings)
            store.commit('dictionaries.set', data.dictionaries)
            store.dispatch('setTableViews', data.tableViews)
            store.dispatch('fetchTableColumnNames')


            _.each(data.teams, team => store.dispatch('processTeam', team))

            store.commit(mutations.APP_HYDRATED)
        })
}
